import VwFontSize from "../../../../content/fluid-typography/vwFontSizeGenerator.tsx";
import MinFnFontSize from "../../../../content/fluid-typography/MinFnGenerator.tsx";
import ClampFnFontSize from "../../../../content/fluid-typography/ClampFnGenerator.tsx";
import * as React from 'react';
export default {
  VwFontSize,
  MinFnFontSize,
  ClampFnFontSize,
  React
};